
import React, { useEffect } from 'react';
import Logger from '@/utils/logger';

declare global {
  interface Window {
    gtag: (...args: any[]) => void;
    dataLayer: any[];
  }
}

const GOOGLE_ANALYTICS_ID = 'G-3CL1HR0DLJ';

const AnalyticsWrapper: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  useEffect(() => {
    initializeGoogleAnalytics();
  }, []);

  const initializeGoogleAnalytics = () => {
    try {
      if (document.querySelector(`script[src*="id=${GOOGLE_ANALYTICS_ID}"]`)) {
        return;
      }

      const script = document.createElement('script');
      script.async = true;
      script.src = `https://www.googletagmanager.com/gtag/js?id=${GOOGLE_ANALYTICS_ID}`;
      
      script.onload = () => {
        window.dataLayer = window.dataLayer || [];
        window.gtag = function gtag(...args: any[]) {
          window.dataLayer.push(args);
        };

        window.gtag('js', new Date());

        window.gtag('config', GOOGLE_ANALYTICS_ID, {
          anonymize_ip: true,
          cookie_flags: 'SameSite=Strict;Secure',
          send_page_view: true,
          allow_google_signals: false,
          allow_ad_personalization_signals: false,
        });

        Logger.info('Google Analytics initialized successfully.');
      };

      script.onerror = () => {
        Logger.error('Failed to load Google Analytics script.');
      };

      document.head.appendChild(script);

    } catch (error) {
      Logger.error('Failed to initialize Google Analytics:', error);
    }
  };

  return <>{children}</>;
};

export const trackPageView = (path: string) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', 'page_view', {
      page_path: path,
      page_title: document.title,
      page_location: window.location.href,
    });
  }
};

export const trackEvent = (action: string, category: string, label?: string, value?: number) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', action, {
      event_category: category,
      event_label: label,
      value: value,
    });
  }
};

export default AnalyticsWrapper;
